{
    "title": "AI settings",
    "description": "Which model answers which capability, what it costs, and what it may see.",
    "provenance": {
        "model": "Suggested by {{model}}",
        "deterministic": "Suggested from keywords",
        "template": "Standard acknowledgement",
        "confidence": "{{percent}}% confidence"
    },
    "analysis": {
        "not_analysed": "Not analysed yet.",
        "risk": "Risk {{score}}",
        "overridden": "Corrected by an officer",
        "rerun": "Re-run analysis",
        "refreshed": "Analysis updated."
    },
    "suggestions": {
        "title": "Suggested resolutions",
        "empty": "Nothing in the knowledge base matches this complaint yet.",
        "relevance": "{{percent}}% match"
    },
    "draft": {
        "title": "Draft reply",
        "generate": "Draft a reply",
        "empty": "Draft a reply to start from. You will be able to edit it before sending.",
        "use": "Use this draft",
        "not_useful": "Not useful",
        "review_note": "Nothing is sent automatically. This goes into your composer for you to edit and send."
    },
    "feedback": {
        "thanks": "Thank you — that has been recorded."
    },
    "providers": {
        "title": "Providers",
        "add": "Add a provider",
        "none": "No provider configured. Everything is running on the built-in deterministic layer.",
        "built_in": "Built in",
        "test": "Test connection",
        "testing": "Testing…",
        "credential": "API key",
        "credential_help": "Stored encrypted and never returned. Leave blank to keep the current key.",
        "credential_set": "Key configured: {{fingerprint}}",
        "offshore": "Sends data outside the Bank",
        "local": "Stays inside the Bank",
        "health": {
            "ok": "Healthy",
            "degraded": "Degraded",
            "down": "Unavailable",
            "unknown": "Not tested"
        }
    },
    "routing": {
        "title": "Capability routing",
        "description": "Each capability can use a different model — or none. Anything left unrouted uses the built-in deterministic layer.",
        "deterministic": "Built-in (deterministic)",
        "sends_text": "Sends the customer's own words",
        "no_text": "Sends no customer text",
        "egress_warning": "Outbound sharing is off, so capabilities that send customer text will use the built-in layer whichever model is selected here.",
        "allow_fallback": "Fall back if this fails",
        "enabled": "Enabled",
        "live": "Live model",
        "fallback_active": "Built-in"
    },
    "playground": {
        "title": "Try it",
        "description": "Run a capability against text of your choosing before it starts handling real complaints.",
        "text": "Text",
        "text_placeholder": "Paste a complaint, in Arabic or English…",
        "run": "Run",
        "result": "Result"
    },
    "usage": {
        "title": "AI usage and cost",
        "description": "What the AI layer did, what it cost, and how much of it needed no model at all.",
        "total_requests": "Requests",
        "deterministic": "Handled without a model",
        "cost": "Spend",
        "budget": "Budget",
        "failed": "Failed",
        "cached": "Served from cache",
        "by_capability": "By capability",
        "by_provider": "By provider",
        "accuracy": "Measured usefulness",
        "accuracy_note": "From officers' own accept, edit and reject verdicts — not from the model's confidence in itself. An edited suggestion counts as half right.",
        "no_spend_note": "Nothing has been spent. Every answer so far came from the built-in deterministic layer.",
        "export": "Export feedback (JSONL)"
    },
    "knowledge": {
        "title": "Knowledge base",
        "description": "What the AI layer may draw answers from. Retrieval respects roles, so a restricted document is never quoted to somebody who cannot open it.",
        "add": "Add a document",
        "empty": "No documents yet.",
        "chunks": "{{count}} passage",
        "chunks_plural": "{{count}} passages",
        "reindex": "Re-index",
        "search": "Test retrieval",
        "search_placeholder": "Ask what an officer would ask…",
        "status": {
            "pending": "Indexing",
            "indexed": "Indexed",
            "failed": "Failed"
        },
        "restricted": "Restricted",
        "visible_to_all": "Everyone"
    }
}
